module.exports = __webpack_public_path__ + "static/media/icon.heart.alone.purple.eb34d9d2.svg";